module.exports = __webpack_public_path__ + "img/I-04522_88-a.5a31c303.jpg";